import { useEffect } from 'react';

const SITE_URL = 'https://nthralabs.com';
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

// Sets per-page title/description/canonical/OG/Twitter tags. `title` should be the
// full page title (including the " | Nthra Labs" suffix where appropriate) — the
// home page is the one exception that shouldn't repeat the brand name twice.
// Runs client-side only — crawlers that don't execute JS (most link-preview bots)
// still see the static defaults baked into public/index.html.
export const useSEO = ({ title, description, path }) => {
  useEffect(() => {
    const url = `${SITE_URL}${path}`;

    document.title = title;
    setMeta('name', 'description', description);
    setCanonical(url);

    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:image', DEFAULT_IMAGE);

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', DEFAULT_IMAGE);
  }, [title, description, path]);
};
